export var BOTPRESS_INTERACTION_ACTIONS = {
  OPEN_CHAT: 'OPEN_CHAT',
  SEND_MESSAGE: 'SEND_MESSAGE',
  SEND_EVENT: 'SEND_EVENT',
  NOTIFY: 'NOTIFY'
};